// crypto.randomUUID chỉ có trong secure context (HTTPS/localhost); có fallback UUID v4 hợp lệ.
export function uuid() {
  const c = globalThis.crypto
  if (c && typeof c.randomUUID === 'function') {
    try { return c.randomUUID() } catch { /* tiếp tục fallback */ }
  }
  const b = new Uint8Array(16)
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(b)
  else for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256)
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80
  const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('')
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}
